var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a-button',{attrs:{"loading":_vm.uploadLoading,"icon":"upload"},on:{"click":_vm.onClick}}),_c('input',{ref:"uploader",attrs:{"id":"uploader","type":"file"},on:{"change":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }